"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Stat = {
  value: number;
  prefix: string;
  suffix: string;
  label: string;
  display: string;
};
const stats: Stat[] = [{
  value: 20,
  prefix: "10+",
  suffix: "+",
  display: "20+",
  label: "Years Experience"
}, {
  value: 5000,
  prefix: "",
  suffix: "+",
  display: "5000+",
  label: "Roofs Restored"
}, {
  value: 1200,
  prefix: "",
  suffix: "+",
  display: "1200+",
  label: "Gutter Systems"
}, {
  value: 100,
  prefix: "",
  suffix: "%",
  display: "100%",
  label: "Satisfaction Rate"
}];
const industries = ["Residential Homes", "Commercial Complexes", "Industrial Parks", "Retail Centers", "Strata Properties", "Office Buildings", "Heritage Sites"];
function CountUp({
  stat,
  start
}: {
  stat: Stat;
  start: boolean;
}) {
  const [current, setCurrent] = useState(0);
  const rafRef = useRef<number | null>(null);
  useEffect(() => {
    if (!start) return;
    const duration = 1500;
    const startTime = performance.now();
    const easeOutQuart = (t: number) => 1 - Math.pow(1 - t, 4);
    const tick = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutQuart(progress);
      setCurrent(stat.value * eased);
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        setCurrent(stat.value);
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
    };
  }, [start, stat.value]);
  const formatted = stat.value % 1 !== 0 ? current.toFixed(1) : Math.floor(current).toLocaleString();
  return;
}
export default function Impact() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.25
  });
  return;
}